import React from "react";
import Button from "../Button";
import { Colors, Text } from "../../config";
import styled from "styled-components";

const backIcon = require("../../assets/images/Arrow_Left.png");

const LoginBackButton = ({ onClick, disabled }) => {
  return (
    <BackButtonWrapper>
      <ButtonWrapper>
        <Button
          label={Text.back}
          onClick={onClick}
          leftImgSrc={backIcon}
          width="6.875rem"
          fontColor={Colors.white}
          fontSize="1rem"
          fontWeight="500"
          bgColor={Colors.whiteOpacity20}
          topBottomPadding="0.5rem"
          labelImgGap="0.5rem"
          disabled={disabled}
        />
      </ButtonWrapper>
      <BackImg src={backIcon} alt="back" onClick={onClick} />
    </BackButtonWrapper>
  );
};

export default LoginBackButton;

const BackButtonWrapper = styled.div`
  position: absolute;
  transform: translate(4rem, 9rem);
  @media only screen and (max-width: 768px) {
    transform: translate(1rem, 2rem);
  }
`;
const ButtonWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
const BackImg = styled.img`
  cursor: pointer;
  @media only screen and (min-width: 769px) {
    display: none;
  }
`;
